export const FETCH_IMPORTED_INVENTORY_REQUEST = 'FETCH_IMPORTED_INVENTORY_REQUEST';
export const FETCH_IMPORTED_INVENTORY_SUCCESS = 'FETCH_IMPORTED_INVENTORY_SUCCESS';
export const FETCH_IMPORTED_INVENTORY_FAILURE = 'FETCH_IMPORTED_INVENTORY_FAILURE';
export const UPLOAD_CSV_REQUEST = 'UPLOAD_CSV_REQUEST';
export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_FAILURE = 'UPLOAD_CSV_FAILURE';
export const UPDATE_IMPORTED_INVENTORY_REQUEST = 'UPDATE_IMPORTED_INVENTORY_REQUEST';
export const UPDATE_IMPORTED_INVENTORY_SUCCESS = 'UPDATE_IMPORTED_INVENTORY_SUCCESS';
export const UPDATE_IMPORTED_INVENTORY_FAILURE = 'UPDATE_IMPORTED_INVENTORY_FAILURE';
export const DELETE_IMPORTED_INVENTORY_REQUEST = 'DELETE_IMPORTED_INVENTORY_REQUEST';
export const DELETE_IMPORTED_INVENTORY_SUCCESS = 'DELETE_IMPORTED_INVENTORY_SUCCESS';
export const DELETE_IMPORTED_INVENTORY_FAILURE = 'DELETE_IMPORTED_INVENTORY_FAILURE';
export const DELETE_ALL_IMPORTED_INVENTORY_REQUEST = 'DELETE_ALL_IMPORTED_INVENTORY_REQUEST';
export const DELETE_ALL_IMPORTED_INVENTORY_SUCCESS = 'DELETE_ALL_IMPORTED_INVENTORY_SUCCESS';
export const DELETE_ALL_IMPORTED_INVENTORY_FAILURE = 'DELETE_ALL_IMPORTED_INVENTORY_FAILURE'; 